module.exports = __webpack_public_path__ + "static/media/Buttons_PDF button.335d79aa.png";